<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div
    class="text-body-2"
  >
    <div
      class="py-1"
    >
      <template>
        <div
          class="d-flex align-start py-2"
        >
          <div style="width: 100%">
            <div

              class="d-flex align-center"
            >
              <div class="text-body-2 font-weight-medium text-capitalize">
                {{ ag.name }}
              </div>
              <v-spacer />

              <v-icon @click="$emit('remove-ag')">
                mdi-delete
              </v-icon>
            </div>
            <div class="d-flex mt-4 flex-wrap">
              <v-chip
                v-if="false"
                class="d-flex align-center justify-center mr-2 mb-2 pa-0"
                label
                outlined
                style="width: 36px;height: 36px"
              >
                <v-icon>mdi-plus</v-icon>
              </v-chip>
              <div
                v-for="a in attributeList"
                :key="a.id"
              >
                <v-chip
                  class="pa-3 mb-2 mr-2 text-body-2 text-capitalize"
                  label
                  large
                  outlined
                  style="height: 36px"
                  @click="toggleAttribute(a.id,ag.id)"
                >
                  {{ a.name }}
                  <v-icon
                    class="ml-2"
                    color="amber darken-2"
                    right
                    small
                  >
                    {{ !isActive(a.id) ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked' }}
                  </v-icon>
                </v-chip>
              </div>
            </div>
          </div>
          <v-spacer />
        </div>
      </template>
    </div>
    <v-divider class="mb-4" />
  </div>
</template>

<script>

export default {
  name: 'AttributeCard',
  components: {},
  props: {
    ag: {},
    selectedAIdList: {}
  },
  data () {
    return {
      agName: ''
    }
  },
  computed: {
    attributeList () {
      return this.ag?.attributes ?? []
    },
    selected () {
      return this.ag?.attributes?.filter(it => this.selectedAIdList.includes(it.id.toString())) ?? []
    }
  },
  watch: {
    ag: {
      immediate: true,
      deep: true,
      handler (val) {
        this.agName = val.name
      }
    }
  },

  methods: {
    isActive (id) {
      return this.selectedAIdList.includes(id.toString())
    },
    toggleAttribute (aId, agId) {
      this.$emit('toggle-attribute', aId, agId)
    }
  }
}
</script>

<style scoped>

</style>
